

import Vue from 'vue';
import MaterialCard from "../views/base/MaterialCard.vue";
import PartyService from "../services/party.service"
import EditPersonForm from "./EditPersonForm.vue";
import {eventBus} from "@/services/event-bus";
import Party from "@/models/party";

export default Vue.extend({
  name: 'PartyList',
  props: {
    userType: {type: String, required: true},
  },
  watch: {
    userType: function (val, oldVal) {
      if (val !== oldVal) {
        this.loadItems();
      }
    }
  },
  components: {
    baseMaterialCard: MaterialCard,
    editPersonForm: EditPersonForm
  },
  methods: {
    loadItems() {
      // eslint-disable-next-line no-console
      //console.log(this.userType);
      if (this.userType === 'therapists') {
        return PartyService.allTherapist().then(d => this.elements = d).catch(reason => eventBus.$emit('error', reason));
      }
      return PartyService.allPatients().then(d => this.elements = d).catch(reason => eventBus.$emit('error', reason));

    },
    refreshPartyList() {
      //todo: odświeżyć bez zaciągania danych z bazy
      this.loadItems()
    },
    createPerson() {
      eventBus.$emit('create-person', 0)
    }
  },
  data() {
    return {
      user: {} as any,
      headers(user: any) {
        let heads = [
          {
            text: 'Name',
            value: 'name',
          },
          {
            text: 'Surname',
            value: 'surname',
          },
          {
            text: 'Mobile',
            value: 'mobile',
          },
        ];
        if (user && user.party ? user.party.type === 'backoffice' : false) {
          heads.push(
              {
                text: 'Login',
                value: 'login',
              },
              {
                text: 'Akcje',
                value: 'actions',
              })
        }
        return heads
      },
      actions: [
        {
          color: 'info',
          icon: 'mdi-account-edit',
          action: (item: any) => {
            eventBus.$emit('edit-person', item.id);
          }
        },
        {
          color: 'red',
          icon: 'mdi-delete-forever',
          action: (item: any) => {
            eventBus.$emit('delete-person', item.id);
          }
        },
      ],
      elements: [] as Party[],
      search: undefined,
      showForm: false,
    }
  },
  mounted(): void {
    this.user = JSON.parse(String(localStorage.getItem('user')));
    this.loadItems();
    eventBus.$on('refresh-party-list', this.refreshPartyList)
  }


});
